import { MdOutlineContentCopy } from 'react-icons/md';
import { Box, Icon, Tooltip } from '@chakra-ui/react';

import { useCopyWithTooltip } from '../../hooks/useCopyWithTooltip';

export const CopyButton = ({
  contentToCopy,
  analyticsEventName,
  analyticstoTrack,
}: {
  contentToCopy: string;
  analyticsEventName: string;
  analyticstoTrack: Record<string, unknown>;
}) => {
  const { handleCopy, handleTooltipOpen, tooltipText } = useCopyWithTooltip(
    contentToCopy,
    analyticsEventName,
    analyticstoTrack
  );

  return (
    <Tooltip
      label={tooltipText}
      placement="top"
      hasArrow
      color="white"
      bg="keyops.blue"
      closeOnClick={false}
      onOpen={handleTooltipOpen}
    >
      <Box _hover={{ cursor: 'pointer' }} onClick={handleCopy}>
        <Icon aria-label="Copy" color="keyops.blue" as={MdOutlineContentCopy} />
      </Box>
    </Tooltip>
  );
};
